import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1973462b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__skeleton-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "header__warning"
}
const _hoisted_4 = { class: "header__wrapper" }
const _hoisted_5 = { class: "header__button-group" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Отчёты ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Показатели ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Организации ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Пользователи ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Отчёты ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Архив ")
const _hoisted_12 = { class: "header__clinic" }
const _hoisted_13 = { class: "header__button-group" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Новый отчет ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Добавить пациента ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Добавить организацию ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Добавить врача ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Настройки ")

import { computed, defineComponent, onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { FLogout } from '@/features/FLogout'
import { useUser } from '@/shared/composables'
import { getDateDistance } from '@/shared/utils'
import IconTemplate from '@/apps/components/IconTemplate.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let getWidth = screen.width

const landingLink = ref<string>()

const router = useRouter()
const route = useRoute()

const { isAuth } = useUser()

const { user } = useUser()

const isSubscriptionEnded = computed(
  () =>
    !getDateDistance(user.value.organization.block_at) ||
    !user.value.organization.package_count
)

const isAuthPage = computed(() => isAuth.value)

const currentMode = computed(() =>
  route.name === 'StatisticPage' ? 'statistic' : 'reports'
)
const isAdmin = computed((): boolean => user.value.role === 'admin')
const isArhiveMode = computed(() => route.query.mode === 'archive')

const currentAdminMode = computed(() =>
  route.path.includes('/organizations') ? 'organizations' : 'users'
)

const handleToggleMode = (mode: string): void => {
  if (mode === 'statistic') {
    router.push({ name: 'StatisticPage' })
  } else {
    router.push({ name: 'PatientListingPage' })
  }
}

const handleToggleAdminMode = (
  mode: 'organizations' | 'users',
  isArchive: boolean
) => {
  if (mode === 'users') {
    router.push({ name: 'UserListingPage' })
  } else {
    router.push({
      name: 'AllOrganizationsPage',
      query: { mode: isArchive ? 'archive' : '' },
    })
  }
}

const handleOpenReportCreationPage = (): void => {
  router.push({
    name: 'ReportCreationPage',
    params: { patientId: 'null-patient' },
  })
}

const handleOpenPatientCreationPage = (): void => {
  router.push({ name: 'PatientCreationPage' })
}

const handleOpenDoctorCreationPage = (): void => {
  router.push({ name: 'UserCreationPage' })
}

const handleCreateOrganization = (): void => {
  router.push('/admin/organizations/create')
}

const handleOpenSettings = (): void => {
  router.push({ name: 'SettingsPage' })
}

const handleOpenReportList = (): void => {
  router.push({ name: 'ReportsPage', query: { page: 1 } })
}

onMounted(() => {
  landingLink.value = window.origin
})

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_skeleton, {
      loading: !_unref(isAuthPage),
      class: "header__skeleton"
    }, {
      template: _withCtx(() => [
        _createVNode(_component_el_skeleton_item, {
          class: "header__skeleton-group",
          variant: "text"
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_skeleton_item, {
            class: "header__skeleton-report",
            variant: "text"
          }),
          _createVNode(_component_el_skeleton_item, {
            class: "header__skeleton-add-patient",
            variant: "text"
          })
        ])
      ]),
      default: _withCtx(() => [
        (_unref(isSubscriptionEnded))
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Внимание! У вас закончилась подписка "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button_group, { class: "header__button" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: _unref(currentMode) === 'reports' ? 'primary' : '',
                  round: "",
                  size: "small",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleToggleMode('reports')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["type"]),
                _createVNode(_component_el_button, {
                  type: _unref(currentMode) === 'statistic' ? 'primary' : '',
                  round: "",
                  size: "small",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleToggleMode('statistic')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["type"])
              ]),
              _: 1
            }),
            (_unref(isAdmin))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_button_group, { class: "header__button" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: _unref(currentAdminMode) === 'organizations' ? 'primary' : '',
                        size: "small",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (handleToggleAdminMode('organizations')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }, 8, ["type"]),
                      _createVNode(_component_el_button, {
                        type: _unref(currentAdminMode) === 'users' ? 'primary' : '',
                        size: "small",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleToggleAdminMode('users')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }, 8, ["type"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    class: "header__button",
                    round: "",
                    size: "small",
                    onClick: handleOpenReportList
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    class: _normalizeClass({ 'header__button--active': _unref(isArhiveMode) }),
                    round: "",
                    size: "small",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (handleToggleAdminMode('organizations', true)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }, 8, ["class"])
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(user).organization.name), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            (!_unref(isSubscriptionEnded))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  class: "header__button",
                  type: "primary",
                  round: "",
                  size: "small",
                  onClick: handleOpenReportCreationPage
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              class: "header__button",
              type: "default",
              round: "",
              size: "small",
              onClick: handleOpenPatientCreationPage
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }),
            (_unref(isAdmin))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_el_button, {
                    class: "header__button",
                    type: "primary",
                    round: "",
                    size: "small",
                    onClick: handleCreateOrganization
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    class: "header__button",
                    type: "default",
                    round: "",
                    size: "small",
                    onClick: handleOpenDoctorCreationPage
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              class: "header__button",
              round: "",
              size: "small",
              onClick: handleOpenSettings
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }),
            _createVNode(_unref(FLogout))
          ])
        ])
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}
}

})